<template>
<svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :class="[`${prefix}-icon`, `${prefix}-icon-psm-field-full`]" width="1em" height="1em" v-bind="$attrs"><defs><path id="svg_89746f2d09__a" d="M0 0L90 0 90 108 0 108z"/></defs><g transform="translate(20 14)" fill="none" fill-rule="evenodd"><mask id="svg_89746f2d09__b" :fill="useCurrentColor ? 'currentColor' : '#fff'"><use xlink:href="#svg_89746f2d09__a"/></mask><path d="M45,0 L86.0868035,8.96738855 C88.3732855,9.46687922 90,11.4585136 90,13.7585004 L90,62.7840887 C90,72.6318061 84.9864095,81.8280139 76.640142,87.2903387 L45,108 L13.359858,87.2903387 C5.0141765,81.8280139 0,72.6318061 0,62.7840887 L0,13.7585004 C0,11.4585136 1.62671428,9.46687922 3.91334282,8.96738855 L45,0 Z M65.0002767,27.8181622 L25.0002767,27.8181622 L25.0002767,37.6361087 L40.0000326,37.6299244 L40.0000326,71.9998563 L49.9999675,71.9998563 L49.9999675,37.6299244 L65.0002767,37.6361087 L65.0002767,27.8181622 Z" :fill="useCurrentColor ? 'currentColor' : '#1BA8AF'" fill-rule="nonzero" mask="url(#svg_89746f2d09__b)"/></g></svg>
</template>
<script>

export default {
  name: 'IconPsmFieldFull',
  props: {
    prefix: {
        type: String,
        default: 'psm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
